/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React, { Component } from 'react';
import { shape, string, object, bool, array, func } from 'prop-types';
import { connect } from 'react-redux';

import Form from 'components/Form/Form';

import styles from './select-method.scss';

/**
 * This is the SelectMethod component.
 *
 * @author Chris Andersson <chris@wbisbi.com>
 */
export class SelectMethod extends Component {
  /**
   * Declare expected prop types.
   *
   * @type {object}
   */
  static propTypes = {
    selectPaymentMethodForm: shape({
      fieldsets: array.isRequired,
      validationMessages: object.isRequired,
      submitText: string.isRequired,
      sending: bool.isRequired,
      errors: object.isRequired,
    }).isRequired,
    onSubmit: func.isRequired,
  };

  /**
   * Render SelectMethod.
   *
   * @return {Object}
   */
  render() {
    const { selectPaymentMethodForm, onSubmit } = this.props;

    return (
      <div className={styles.wrapper}>
        <div className={styles.content}>
          <Form {...selectPaymentMethodForm} onSubmit={onSubmit} />
        </div>
      </div>
    );
  }
}

export default connect(({ selectPaymentMethodForm }) => ({
  selectPaymentMethodForm,
}))(SelectMethod);
